export class HorribleHeroesGameMode {
    public static readonly NORMAL: string = "NORMAL";
    static readonly FREESPIN_PICK: string = "FREESPIN_PICK";
    static readonly FREESPIN_MID: string = "FREESPIN_MID";
    static readonly FREESPIN_LOW: string = "FREESPIN_LOW";
}